import { requests } from '../api'
import { outboundInterface } from './outboundInterface'

export const outbound = {
    getPosts: (search: string): Promise<outboundInterface[]> =>
        requests.get(`/messages/search?senders[0]=${search}`)
}
